import { AbstractPmsApiService } from "./abstract.service";
import { DefaultPropertyAmenity } from "../models";

/**
 * @class DefaultPropertyAmenityPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<DefaultPropertyAmenity>}
 */
export class DefaultPropertyAmenityPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/amenity-category/:amenityCategoryId/default-property-amenity(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {DefaultPropertyAmenity}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new DefaultPropertyAmenity(attributes);
    }
    
    /**
     * @param {Object} params
     * @param {AmenityCategory} amenity_category
     * @returns {Promise.<PaginationCollection<DefaultPropertyAmenity>>}
     */
    get (params = {}, amenity_category = null) {
        
        const url = this.url({amenityCategoryId: amenity_category ? amenity_category.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {DefaultPropertyAmenity} amenity
     * @returns {Promise.<DefaultPropertyAmenity>}
     */
    show(defaultPropertyAmenity) {
        
        const url = this.url({amenityCategoryId: defaultPropertyAmenity.category_id, id: defaultPropertyAmenity.id});

        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {DefaultPropertyAmenity} defaultPropertyAmenity
     * @param {AmenityCategory} amenity_category
     * @returns {Promise.<defaultPropertyAmenity>}
     */
    create(defaultPropertyAmenity, amenity_category) {
        
        const url = this.url({amenityCategoryId: amenity_category.id});

        return this.http
                   .post(url, defaultPropertyAmenity.toObjectExcept('amenity_category'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {DefaultPropertyAmenity} defaultPropertyAmenity
     * @returns {Promise.<DefaultPropertyAmenity>}
     */
    update(defaultPropertyAmenity) {
        
        const url = this.url({
            amenityCategoryId: defaultPropertyAmenity.amenity_category.id,
            id: defaultPropertyAmenity.id
        });
        
        return this.http
                   .put(url, defaultPropertyAmenity.toObjectExcept('amenity_category'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {DefaultPropertyAmenity} defaultPropertyAmenity
     * @returns {Promise.<boolean>}
     */
    delete(defaultPropertyAmenity) {
        
        const url = this.url({
            amenityCategoryId: defaultPropertyAmenity.amenity_category.id,
            id: defaultPropertyAmenity.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/default-property-amenity.service.js